import * as React from "react"
import { clsx } from "clsx"

export interface ScrollAreaProps {
  children?: React.ReactNode
  className?: string
}

export const ScrollArea = React.forwardRef<
  HTMLDivElement,
  ScrollAreaProps
>(({ className, children, ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={clsx("ds-scroll-area", className)}
      {...props}
    >
      {children}
    </div>
  )
})

ScrollArea.displayName = "ScrollArea"
